<template>
  <v-dialog v-model="dialog" width="800">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        depressed
        class="rounded-lg"
        v-bind="attrs"
        v-on="on"
      >
        Nuevo asiento
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ paymentId ? "Editar" : "Asiento manual" }}

        <v-spacer></v-spacer>

        <div>
          <v-btn-toggle
            v-model="payment.billed"
            class="fill-width"
            mandatory
            dense
          >
            <v-btn
              :value="true"
              color="white"
              style="width: 50%"
              active-class="primary white--text"
            >
              FC
            </v-btn>
            <v-btn
              :value="false"
              color="white"
              style="width: 50%"
              active-class="primary white--text"
            >
              NO/FC
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-card-title>

      <v-card-text>
        <v-form lazy-validation v-model="valid" ref="form">
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                v-if="canEdit"
                v-model="accountId"
                label="Cuenta"
                :items="accounts"
                item-text="name"
                item-value="id"
                filled
                hint="Obligatorio"
                :rules="rules.required"
                persistent-hint
              ></v-autocomplete>
            </v-col>

            <v-col cols="4">
              <v-select
                :disabled="!(canEdit && accountId && subaccounts.length)"
                v-model="payment.subAccountId"
                label="Subcuenta"
                :items="subaccounts"
                item-text="name"
                item-value="id"
                filled
                hint="Obligatorio"
                :rules="rules.required"
                persistent-hint
              ></v-select>
            </v-col>

            <v-col cols="4">
              <v-autocomplete
                :disabled="
                  !(canEdit && payment.subAccountId && concepts.length)
                "
                v-model="concept"
                label="Concepto"
                :items="concepts"
                item-text="name"
                return-object
                filled
                :hint="concepts.length ? 'Obligatorio' : ''"
                :rules="concepts.length ? rules.required : []"
                persistent-hint
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4">
              <v-btn-toggle v-model="sign" class="fill-width" mandatory>
                <v-btn
                  value="-"
                  color="white"
                  active-class="blue lighten-1 white--text py-5"
                  style="width: 50%; height: auto !important"
                >
                  Egreso
                </v-btn>
                <v-btn
                  value="+"
                  color="white"
                  style="width: 50%; height: auto !important"
                  active-class="blue lighten-1 white--text py-5"
                >
                  Ingreso
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col cols="4">
              <v-text-field
                filled
                v-model="payment.amount"
                label="Monto"
                placeholder="5000"
                type="number"
                min="0"
                hint="Obligatorio"
                persistent-hint
                prefix="$"
                :rules="rules.min"
              >
              </v-text-field>
            </v-col>

            <v-col cols="4">
              <v-menu
                v-model="startMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="payment.paidAt"
                    label="Fecha de pago"
                    append-icon="mdi-calendar-blank"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="payment.paidAt"
                  @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <div>
            <v-text-field
              filled
              v-model="payment.detail"
              label="Observaciones"
              type="text"
              persistent-hint
            ></v-text-field>
          </div>

          <div class="mt-3 d-flex align-center" style="gap: 8px">
            <span class="text-subtitle-1 text--primary">Forma de pago:</span>

            <div>
              <v-radio-group
                hide-details
                class="mt-0 text-h6"
                :column="false"
                mandatory
                v-model="payment.paymentType"
              >
                <v-radio
                  v-for="n in ['Efectivo', 'Cheque', 'Transferencia']"
                  class="mr-3"
                  :key="n"
                  :label="n"
                  :value="n"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions class="text-right justify-end pa-5">
        <v-btn color="primary" @click="createPayment">
          {{ paymentId ? "Guardar" : "Crear" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CreatePayment, EditPayment } from "@/graphql/mutations/payments";
import { Payment } from "@/graphql/queries/payment";

import { Accounts } from "@/graphql/queries/account";
import { SubAccounts } from "@/graphql/queries/subAccount";
import { Concepts } from "@/graphql/queries/concepts";

import { ListContacts } from "@/graphql/queries/directory";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      accountId: null,
      startMenu: false,
      dialog: false,
      concepts: [],
      concept: null,
      payment: {
        detail: null,
        subAccountId: null,
        amount: null,
        paymentType: "Efectivo",
        paidAt: new Date().toISOString().substr(0, 10),
        dueDate: new Date().toISOString().substr(0, 10),
        concept: null,
        conceptId: null,
        referralType: "Agency",
        referralId: null,
        receiverType: null,
        receiverId: null,
        period: "1",
        state: "paid"
      },
      sign: null,
      accounts: [],
      subaccounts: [],
      referrals: [],
      receivers: [{ name: null, receiverType: null, receiverId: null }],
      referral: {
        referralType: null,
        referralId: null,
        name: null
      },
      receiver: {
        receiverType: null,
        receiverId: null,
        name: "Externo"
      },
      rules: {
        required: [v => !!v || "Campo obligatorio"],
        min: [v => !!v || "Campo obligatorio"]
      },
      valid: true
    };
  },

  props: {
    paymentId: {
      required: false,
      default: null
    },

    contract: {
      required: false,
      type: Object
    }
  },

  watch: {
    dialog: {
      handler(val) {
        if (val) {
          if (this.contract) {
            this.payment.referralType = "User";
            this.payment.referralId = this.contract.tenant[0].id;
            this.payment.contractId = this.contract.id;
          } else {
            this.payment.referralId = this.currentUser.selectedAgency.id;
          }

          this.receivers.push({
            name: "Inmobiliaria",
            receiverId: this.currentUser.selectedAgency.id,
            receiverType: "Agency"
          });

          this.referrals.push({
            name: "Inmobiliaria",
            referralId: this.currentUser.selectedAgency.id,
            referralType: "Agency"
          });

          this.fetchAccounts();
          // this.fetchSubAccounts()
          // this.fetchContacts()

          if (this.paymentId) {
            this.fetchPayment();
          }
        }
      }
    },

    referral: {
      handler(val) {
        this.payment.referralType = val.referralType;
        this.payment.referralId = val.referralId;
      },

      deep: true
    },

    receiver: {
      handler(val) {
        this.payment.receiverType = val.receiverType;
        this.payment.receiverId = val.receiverId;
      },

      deep: true
    },

    accountId: {
      handler() {
        this.fetchSubAccounts();
      }
    },

    "payment.subAccountId": {
      handler() {
        this.fetchConcepts();
      }
    },

    concept: {
      handler(val) {
        this.payment.concept = val.name;
        this.payment.conceptId = val.id;
      },

      deep: true
    }
  },

  computed: {
    ...mapGetters(["currentUser"]),

    canEdit() {
      return !this.paymentId || this.payment.canEdit;
    },

    paymentAttributes() {
      return {
        subAccountId: this.payment.subAccountId,
        paymentType: this.payment.paymentType,
        amount: this.payment.amount,
        paidAt: this.payment.paidAt,
        detail: this.payment.detail,
        dueDate: new Date(),
        concept: this.payment.concept,
        conceptId: this.payment.conceptId,
        referralType: this.payment.referralType,
        referralId: this.payment.referralId,
        receiverType: this.payment.receiverType,
        receiverId: this.payment.receiverId,
        period: this.payment.period,
        state: this.payment.state,
        sign: this.payment.sign
      };
    }
  },

  methods: {
    createPayment() {
      if (this.valid) this.valid = this.$refs.form.validate();
      if (this.valid) {
        if (this.contract) {
          this.$emit("created", this.paymentAttributes);
          this.dialog = false;
        } else {
          this.payment.amount = parseFloat(this.sign + this.payment.amount);

          let mutation = this.paymentId ? EditPayment : CreatePayment;

          let variables = this.paymentId
            ? {
                input: {
                  attributes: this.paymentAttributes,
                  paymentId: this.paymentId
                }
              }
            : {
                input: {
                  attributes: this.paymentAttributes
                }
              };

          this.$apollo
            .mutate({
              mutation: mutation,
              variables: variables
            })
            .then(res => {
              this.$emit("reload");
              this.dialog = false;
            })
            .catch(err => {
              console.log(err);
              this.payment.amount = Math.abs(this.payment.amount);
            });
        }
      }
    },

    fetchPayment() {
      this.$apollo
        .query({
          query: Payment,
          variables: {
            id: this.paymentId
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.payment = res.data.payment;

          this.sign =
            Math.abs(this.payment.amount) == this.payment.amount ? "+" : "-";
          this.payment.amount = Math.abs(this.payment.amount);

          this.receiver = {
            name:
              this.payment.receiverType == "Agency"
                ? "Inmobiliaria"
                : this.payment.receiverName,
            receiverType: this.payment.receiverType,
            receiverId: this.payment.receiverId
          };
        });
    },

    fetchContacts(firstLoad = false) {
      this.$apollo
        .query({
          query: ListContacts,
          variables: {
            noPaginate: true
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          let contacts = res.data.contacts.contacts;
          contacts.forEach(contact => {
            this.referrals.push({
              name: contact.profile.name,
              referralType: "User",
              referralId: contact.id
            });

            this.receivers.push({
              name: contact.profile.name,
              receiverType: "User",
              receiverId: contact.id
            });
          });
        });
    },

    fetchAccounts() {
      this.$apollo
        .query({
          query: Accounts,
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.accounts = res.data.accounts;
          this.count += 1;
        });
    },

    fetchSubAccounts() {
      this.$apollo
        .query({
          query: SubAccounts,
          variables: {
            isolated: false,
            accountId: this.accountId
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.subaccounts = res.data.subAccounts;
        });
    },

    fetchConcepts() {
      this.$apollo
        .query({
          query: Concepts,
          variables: {
            subAccountId: this.payment.subAccountId
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.concepts = res.data.concepts;
        });
    }
  }
};
</script>
